import { AppRoles, SubRoles } from "../enums/role.enum";
import { IUser } from "../interfaces/user.interface";

export const getPortalText = (user: IUser | null, isMobile = true) => {
    if (user) {
        const isParent = user.role === AppRoles.PARENT;
        const isClinician = user.role === AppRoles.CLINICIAN;
        const isTeacher = user.parentInfo?.subRole === SubRoles.TEACHER;

        if (isParent) {
            return isMobile ? "Parent Portal" : "parent portal";
        }

        if (isTeacher) {
            return isMobile ? "Teacher Portal" : "teacher portal";
        }

        if (isClinician) {
            return isMobile ? "Clinician Portal" : "clinician portal";
        }
    }
};
